module.exports = __webpack_public_path__ + "img/concact.7d8c2b76.png";